import { type CreateRelatedEntityStep } from 'pages/AutomationEngine/dialogs/ActionWizard/subsections/actionSectionTypes';
import DraggableStepCard, { DraggableStepCardProps } from '../../DraggableStepCard';
import { type TFunction } from 'react-i18next';

export const content = ({ step }: { step: CreateRelatedEntityStep }) =>
  step.description;

export const getDescription = ({
  step,
  t,
}: {
  step: CreateRelatedEntityStep;
  t: TFunction;
}) => {
  return t('Create ‘{{relatedObjectName}}’{{more}}', {
    relatedObjectName: [
      step.details.targetCustomObject?.label,
      step.details.targetCustomObject?.deleted && ` [${t('Deleted')}]`,
    ]
      .filter(Boolean)
      .join(''),
    more: t('{{contextEntityField}}{{targetVariable}}', {
      targetVariable: step.details.targetVariable
        ? ` ${t('and update variable ‘{{targetVariableName}}’', {
            targetVariableName: [
              step.details.targetVariable?.label,
              step.details.targetVariable?.deleted && ` [${t('Deleted')}]`,
            ]
              .filter(Boolean)
              .join(''),
          })}`
        : '',
      contextEntityField: step.details.contextEntityField
        ? ` ${t('and update field ‘{{contextEntityFieldName}}’', {
            contextEntityFieldName: [
              step.details.contextEntityField?.label,
              step.details.contextEntityField?.deleted && ` [${t('Deleted')}]`,
            ]
              .filter(Boolean)
              .join(''),
          })}`
        : '',
    }),
  });
};

export default function CreateRelatedEntityCard({
  step,
  ...others
}: {
  step: CreateRelatedEntityStep;
} & DraggableStepCardProps) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
